function absAssetUrl (path) {
    if (!path) return path
    if (/^https?:\/\//i.test(path)) return path
    return path.startsWith('/') ? path : `/${path}`
}

function makeGalleryMap (entries) {
    return new Map(
        entries.map(([key, paths]) => [key, paths.map(absAssetUrl)])
    )
}

function buildMapFromSettings (settingsMap) {
    if (!settingsMap || typeof settingsMap !== 'object') return null

    const entries = Object.entries(settingsMap)
        .map(([key, urls]) => [String(key), Array.isArray(urls) ? urls : []])
        .filter(([, urls]) => urls.length > 0)

    if (!entries.length) return null

    return makeGalleryMap(entries)
}

function getPlanGalleryMap () {
    const mapFromSettings = buildMapFromSettings(window.__PLAN_GALLERIES__)
    if (mapFromSettings) return mapFromSettings
    return null
}

let galleryMainSwiper = null
let galleryThumbsSwiper = null
let prevHtmlOverflow = ''
let prevBodyOverflow = ''
let hadFixedBody2Class = false

function openPlanGallery (urls) {
    closePlanGallery()

    const modal = document.getElementById('plan-gallery-modal')
    if (!modal) return

    const mainWrap = modal.querySelector('.plan__images-big .swiper-wrapper')
    const thumbsWrap = modal.querySelector('.plan__images-small .swiper-wrapper')
    const mainEl = modal.querySelector('.plan__images-big.mySwiper2')
    const thumbsEl = modal.querySelector('.plan__images-small.mySwiper')
    const nextBtn = modal.querySelector('.swiper-button-next')
    const prevBtn = modal.querySelector('.swiper-button-prev')
    const thumbsBox = modal.querySelector('.plan__images-wrap')

    if (!mainWrap || !thumbsWrap || !mainEl || !thumbsEl || !nextBtn || !prevBtn || !thumbsBox) {
        return
    }

    mainWrap.innerHTML = ''
    thumbsWrap.innerHTML = ''

    urls.forEach((u, index) => {
        const mainSlide = document.createElement('div')
        mainSlide.className = 'swiper-slide'
        const mainImg = document.createElement('img')
        mainImg.loading = 'lazy'
        mainImg.src = u
        mainImg.alt = ''
        mainSlide.appendChild(mainImg)
        mainWrap.appendChild(mainSlide)

        const thumbSlide = document.createElement('div')
        thumbSlide.className = 'swiper-slide'
        thumbSlide.dataset.thumbIndex = String(index)
        const thumbImg = document.createElement('img')
        thumbImg.loading = 'lazy'
        thumbImg.src = u
        thumbImg.alt = ''
        thumbSlide.appendChild(thumbImg)
        thumbsWrap.appendChild(thumbSlide)
    })

    const single = urls.length <= 1
    nextBtn.style.display = single ? 'none' : ''
    prevBtn.style.display = single ? 'none' : ''
    thumbsBox.style.display = single ? 'none' : ''

    prevHtmlOverflow = document.documentElement.style.overflow
    prevBodyOverflow = document.body.style.overflow
    hadFixedBody2Class = document.body.classList.contains('fixed-body2')
    document.documentElement.style.overflow = 'hidden'
    document.body.style.overflow = 'hidden'
    document.body.classList.add('fixed-body2')

    modal.hidden = false
    modal.classList.add('plan__images--active')
    modal.setAttribute('aria-hidden', 'false')

    if (!window.Swiper) {
        console.error('Swiper не найден: ожидается window.Swiper из resources/js/globals.js')
        return
    }

    galleryThumbsSwiper = new window.Swiper(thumbsEl, {
        slidesPerView: 6,
        spaceBetween: 8,
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true
    })

    galleryMainSwiper = new window.Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: false,
        roundLengths: true,
        watchOverflow: true,
        navigation: { nextEl: nextBtn, prevEl: prevBtn },
        observer: true,
        observeParents: true,
        on: {
            init () {
                this.update()
            }
        }
    })

    const syncActiveThumb = (index) => {
        const thumbSlides = thumbsEl.querySelectorAll('.swiper-slide')
        thumbSlides.forEach((slide, slideIndex) => {
            slide.classList.toggle('swiper-slide-thumb-active', slideIndex === index)
        })
        if (galleryThumbsSwiper) {
            galleryThumbsSwiper.slideTo(index)
        }
    }

    syncActiveThumb(galleryMainSwiper.activeIndex || 0)
    galleryMainSwiper.on('slideChange', () => {
        syncActiveThumb(galleryMainSwiper.activeIndex || 0)
    })

    thumbsEl.onclick = (event) => {
        const thumbSlide = event.target.closest('.swiper-slide')
        if (!thumbSlide || !thumbsEl.contains(thumbSlide) || !galleryMainSwiper) {
            return
        }

        const idx = Number(thumbSlide.dataset.thumbIndex)
        if (Number.isNaN(idx) || idx < 0) return

        galleryMainSwiper.slideTo(idx)
    }
}

function closePlanGallery () {
    const modal = document.getElementById('plan-gallery-modal')
    if (!modal) return

    if (galleryMainSwiper) {
        galleryMainSwiper.destroy(true, true)
        galleryMainSwiper = null
    }

    if (galleryThumbsSwiper) {
        galleryThumbsSwiper.destroy(true, true)
        galleryThumbsSwiper = null
    }

    const mainWrap = modal.querySelector('.plan__images-big .swiper-wrapper')
    const thumbsWrap = modal.querySelector('.plan__images-small .swiper-wrapper')
    if (mainWrap) mainWrap.innerHTML = ''
    if (thumbsWrap) thumbsWrap.innerHTML = ''

    modal.classList.remove('plan__images--active')
    modal.hidden = true
    modal.setAttribute('aria-hidden', 'true')

    document.documentElement.style.overflow = prevHtmlOverflow || ''
    document.body.style.overflow = prevBodyOverflow || ''
    if (!hadFixedBody2Class) {
        document.body.classList.remove('fixed-body2')
    }
}

document.addEventListener('click', e => {
    const closeTrigger = e.target.closest('[data-gallery-close]')
    if (closeTrigger) {
        closePlanGallery()
        return
    }

    const modalBackdrop = e.target.closest('#plan-gallery-modal')
    if (modalBackdrop && e.target === modalBackdrop) {
        closePlanGallery()
        return
    }

    const pin = e.target.closest('.plan__btn[data-slider-path]')
    if (!pin) return
    const key = String(pin.getAttribute('data-slider-path') || '')
    const galleryMap = getPlanGalleryMap()
    const urls = galleryMap ? galleryMap.get(key) : null
    if (urls && urls.length) {
        openPlanGallery(urls)
    } else {
        console.warn('Нет галереи для data-slider-path =', key)
    }
})

document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
        closePlanGallery()
    }
})
